import React, { Component } from 'react';
import { Modal, Row, Button, Table, Input, } from "antd";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import "../../app/index.scss";
import "../../setting/index.scss";

@inject('store')
@observer
class SelectHotel extends Component {
    componentDidMount() {
        this.props.store.selectHotel.getData();
    }
    render() {
        const { visible, onChange, onSearch, onOk, onCancel, name, hotel, selectedRowKeys, onChangeRowKeys } = this.props.store.selectHotel;
        const { promiseFn } = this.props;
        // 酒店列表
        const columnsHotel = [{
            title: 'key',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '联系人',
            dataIndex: 'contacts',
            key: 'contacts',
        }, {
            title: '地址',
            dataIndex: 'address',
            key: 'address',
        }, {
            title: '联系电话',
            key: 'tel',
            dataIndex: 'tel',
        }];

        const rowSelection = {
            selectedRowKeys,
            onChange: onChangeRowKeys,
            type: 'radio'
        };
        return (
            <Modal
                title={'酒店选择'}
                visible={visible}
                onOk={onOk.bind(this, promiseFn)}
                onCancel={onCancel}
                className="compared-modal"
                footer={
                    [
                        <Button key="back" onClick={onCancel}>取消</Button>,
                        <Button key="submit" type="primary" onClick={onOk.bind(this, promiseFn)}>
                            确定
                </Button>,
                    ]}
            >
                <Row  >
                    <span>酒店名称：</span>
                    <Input
                        style={{ width: 200, marginRight: 10 }}
                        value={name}
                        onChange={onChange}
                        onPressEnter={onSearch}
                    />
                    <Button
                        type="primary"
                        onClick={onSearch}
                    >搜索</Button>
                </Row>
                <Table
                    style={{ marginTop: 10 }}
                    columns={columnsHotel}
                    dataSource={toJS(hotel)}
                    bordered
                    className="hotelModal"
                    rowSelection={rowSelection}
                    rowKey={item => item.id}
                />
            </Modal>
        );
    }
}

export default SelectHotel;


// WEBPACK FOOTER //
// ./src/components/BI/headquarters/SelectHotel.js